/* eslint-disable no-underscore-dangle */
import React from 'react';

import BLOG_POST_QUERY from '../../src/queries/blogPost.graphql';
import BLOG_POSTS_QUERY from '../../src/queries/blogPosts.graphql';

import Page from '../../src/components/Page';
import Meta from '../../src/components/Meta';

import HandbookPost from '../../src/components/HandbookPost';

import {
  BlogPostQuery,
  PageGenericFragment,
  BlogPostContentFragment,
  BlogPostNavigationFragment,
} from '../../src/schemas/api';

import api from '../../src/utils/api';

export async function getStaticProps({ params }) {
  const results: BlogPostQuery = await api(BLOG_POST_QUERY, {
    page: `handbook/${params.slug}`,
  });

  return {
    props: {
      pageGeneric: results.pageGeneric,
      post: results.blogPost.items[0],
      navigation: results.page.items.flatMap((d) => {
        return d.blocks.items.flatMap((item) => {
          if (!('list' in item)) return [];
          return item.list.items.flatMap((d) => {
            return d;
          });
        });
      }),
    },
  };
}

export async function getStaticPaths() {
  const result: BlogPostQuery = await api(BLOG_POSTS_QUERY, {
    type: ['Handbook'],
  });

  const paths = result.blogPost.items
    .filter((p) => !!p.slug && p.slug !== '/' && !p.comingSoon)
    .map((p) => {
      const segments = p.slug.split('/');
      return { params: { slug: segments[1] || segments[0] } };
    });

  return { paths, fallback: false };
}

type BlogPostPageProps = {
  post: BlogPostContentFragment;
  pageGeneric: PageGenericFragment;
  navigation: BlogPostNavigationFragment[];
};

function BlogPostPage({ post, pageGeneric, navigation }: BlogPostPageProps) {
  return (
    <Page generic={pageGeneric}>
      <Meta
        title={post.title}
        description={post.short}
        image={post.image}
        indexable={true}
        slug={`${post.slug}/`}
      />
      <HandbookPost data={post} navigation={navigation} />
    </Page>
  );
}

export default BlogPostPage;
